module.exports = require('./dist/react');



/*****************
 ** WEBPACK FOOTER
 ** ./~/@storybook/addon-links/react.js
 ** module id = 568
 ** module chunks = 0
 **/